var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgApproved(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    rx: 8,
    fill: "#71A282"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.2186 5.18484C12.3368 5.30309 12.4032 5.46345 12.4032 5.63066C12.4032 5.79787 12.3368 5.95823 12.2186 6.07649L7.49216 10.8029C7.4297 10.8654 7.35554 10.915 7.27392 10.9488C7.19231 10.9826 7.10483 11 7.01648 11C6.92814 11 6.84066 10.9826 6.75905 10.9488C6.67743 10.915 6.60327 10.8654 6.54081 10.8029L4.19251 8.45506C4.13228 8.39689 4.08424 8.32731 4.0512 8.25037C4.01815 8.17344 4.00075 8.09069 4.00002 8.00696C3.9993 7.92323 4.01525 7.8402 4.04696 7.7627C4.07866 7.6852 4.12549 7.6148 4.18469 7.55559C4.2439 7.49638 4.31431 7.44956 4.3918 7.41785C4.4693 7.38615 4.55234 7.37019 4.63607 7.37092C4.71979 7.37165 4.80254 7.38904 4.87947 7.42209C4.95641 7.45514 5.02599 7.50318 5.08416 7.56341L7.01627 9.49552L11.3265 5.18484C11.3851 5.12624 11.4546 5.07975 11.5312 5.04804C11.6077 5.01632 11.6897 5 11.7726 5C11.8554 5 11.9374 5.01632 12.014 5.04804C12.0905 5.07975 12.16 5.12624 12.2186 5.18484Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApproved);
export default __webpack_public_path__ + "static/media/approved.a4c22c452684c390b03b73cfd6bf26f7.svg";
export { ForwardRef as ReactComponent };